<template>
  <div class="container-lg clearfix px-2">
    <div v-show="loading">
      <h2><span>Loading</span><span class="AnimatedEllipsis"></span></h2>
    </div>
    <gmap-map
      :center="{ lat: 42.684639575536096, lng: -71.02666927101306 }"
      :zoom="12"
      :options="{
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        disableDefaultUi: false,
        fullscreenControl: false
      }"
    >
      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPosition"
        :opened="infoWindowOpen"
        @closeclick="closeInfoWindow"
      >
      </gmap-info-window>
      <HydrantMarker
        v-for="hydrant in hydrants"
        :key="hydrant.id"
        :hydrant="hydrant"
        v-on:show-info-window="showInfoWindow"
        :ref="'hydrant-' + hydrant.id"
      />
      <CurrentLocationMarker />
    </gmap-map>
  </div>
</template>

<style lang="scss">
.vue-map-container {
  min-height: 625px;
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
}
</style>

<script>
import HydrantMarker from "../components/HydrantMarker";
import CurrentLocationMarker from "../components/CurrentLocationMarker";

export default {
  name: "MapView",
  components: {
    HydrantMarker,
    CurrentLocationMarker
  },
  data() {
    return {
      infoWindowPosition: null,
      infoWindowOpen: false,
      currentHydrantId: null,
      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },
  created() {
    this.$store.dispatch("getEverything").then(() => {
      const previousInfoWindow = this.$refs[window.location.hash.substr(1)];

      if (previousInfoWindow) {
        previousInfoWindow[0].showInfoWindow();
      }
    });
  },
  computed: {
    showMuniHydrants() {
      return this.$store.state.showMuniHydrantsV2;
    },
    showLocation() {
      return this.$store.state.showLocation;
    },
    hydrants() {
      const hydrants = this.$store.state.hydrants;

      if (this.showMuniHydrants) {
        return hydrants;
      }
      return hydrants.filter(hydrant => {
        return hydrant.hydrant_type != "muni";
      });
    },
    hydrantCount() {
      return this.hydrants.length;
    },
    loading() {
      return this.hydrantCount === 0;
    }
  },
  methods: {
    closeInfoWindow: function() {
      window.location.hash = "";
      this.infoWindowOpen = false;
    },
    showInfoWindow: function(hydrant, content) {
      window.location.hash = `hydrant-${hydrant.id}`;
      this.infoWindowPosition = hydrant.position;
      this.infoOptions.content = content;

      if (this.currentHydrantId == hydrant.id) {
        this.infoWindowOpen = !this.infoWindowOpen;
      } else {
        this.infoWindowOpen = true;
        this.currentHydrantId = hydrant.id;
      }
    }
  }
};
</script>
